import debounce from '../../../helpers/debounce.js'

export const viewportSize = () => {
	const viewportSizeFn = () => document.querySelector(':root').style.setProperty('--vp-height', `${window.visualViewport.height}px`);
	window.addEventListener('resize', debounce(() => document.querySelector(':root').style.setProperty('--vp-height', `${window.visualViewport.height}px`), 50));
	viewportSizeFn();
}
